import { AC_GROUPS, AC_TYPES } from '../AC.types.constant';
import { CriterionType } from '../../../types/screener.type';

const dividendAC: CriterionType[] = [
  {
    id: 'DIV-10',
    label: 'Dividend yield (%)',
    shortLabel: 'DivYld',
    unit: '%',
    group: AC_GROUPS.dividend,
    type: AC_TYPES.normal,
    withRange: true,
  },
];

export default dividendAC;
